import React, { useContext } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { highlightRed, highlightOrange, highlightYellow, highlightGreen, highlightBlue, highlightDarkBlue, highlightPurple, highlightPink, highlightBrown, highlightGrey } from "@churchofjesuschrist/eden-style-constants";
import RowSelectionContext from "./RowSelection/Context";
import TableSectionContext from "./Table/TableSectionContext";
import TD from "./TD";
import { TableContext } from "./Table/Table";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const highlights = {
  red: highlightRed,
  orange: highlightOrange,
  yellow: highlightYellow,
  green: highlightGreen,
  blue: highlightBlue,
  darkblue: highlightDarkBlue,
  purple: highlightPurple,
  pink: highlightPink,
  brown: highlightBrown,
  grey: highlightGrey
};

// The `&&&` is to override the specificity of the "striped" styles in `Table`.
const Root = styled.tr.withConfig({
  componentId: "sc-zkgtp5-0"
})(["", ";"], _ref => {
  let {
    highlighted,
    highlightColor
  } = _ref;
  return highlighted ? `&&& { background-color: ${highlightColor}; }` : "";
});

/** Represents a row of cells in a table. */
export default function TR(_ref2) {
  var _rowSelection$selecte;
  let {
    children,
    highlighted,
    highlightColor = "darkblue",
    id,
    ...props
  } = _ref2;
  const tableSection = useContext(TableSectionContext);
  const rowSelection = useContext(RowSelectionContext);
  const renderRowChildren = useContext(TableContext);
  return /*#__PURE__*/_jsxs(Root, {
    ...props,
    id: id,
    role: "row",
    highlighted: highlighted || (rowSelection === null || rowSelection === void 0 ? void 0 : (_rowSelection$selecte = rowSelection.selected) === null || _rowSelection$selecte === void 0 ? void 0 : _rowSelection$selecte.includes(id)),
    highlightColor: highlights[highlightColor],
    children: [rowSelection ? tableSection === "thead" && !props.noSelection ? /*#__PURE__*/_jsx(rowSelection.SelectAllCell, {}) : tableSection === "tbody" && !props.noSelection ? /*#__PURE__*/_jsx(rowSelection.SelectRowCell, {
      id: id
    }) : /*#__PURE__*/_jsx(TD, {}) : null, renderRowChildren(children)]
  });
}
TR.propTypes = {
  /** The row cells. */
  children: PropTypes.node,
  /** A unique identifier for the row. This is required if a `<RowSelection>` anscestor is present. It also renders as the `id` attribute, so it must be unique on the page. */
  id: PropTypes.string,
  /** The highlight color to apply when `highlighted` is true. */
  highlightColor: PropTypes.oneOf(["red", "orange", "yellow", "green", "blue", "darkblue", "purple", "pink", "brown", "grey"]),
  /** Whether the row is highlighted. */
  highlighted: PropTypes.bool

  /** INTERNAL PROPS */

  /** If a "row selection" control should not be shown when it otherwise would. */
  // noSelection: PropTypes.bool
};